import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import ScreenSaverView from "../views/ScreenSaverView.vue";
import IFrameView from "../views/IFrameView.vue";

const routes = [
  {
    path: "/:lang(fr|de)?",
    children: [
      {
        path: "",
        name: "screensaver",
        component: ScreenSaverView,
      },
      {
        path: "home",
        name: "home",
        component: HomeView,
        props: (route) => ({
          buttons: getButtons(route.params.lang || "fr", "home"),
        }),
      },
      {
        path: "formations-bachelor",
        name: "formations-bachelor",
        component: HomeView,
        props: (route) => ({
          buttons: getButtons(route.params.lang || "fr", "formations_bachelor"),
        }),
      },
      {
        path: "formation-continue",
        name: "formation-continue",
        component: HomeView,
        props: () => ({
          buttons: getButtons("de", "formation_continue"),
        }),
      },
      {
        path: "instituts-recherche",
        name: "instituts-recherche",
        component: HomeView,
        props: (route) => ({
          buttons: getButtons(route.params.lang || "fr", "instituts"),
        }),
      },
      {
        path: "site",
        name: "site",
        component: IFrameView,
        props: (route) => ({ iframeUrl: route.query.url }),
      },
    ],
  },
];

const buttonsConfig = {
  fr: {
    home: [
      {
        text: "Formations Bachelor",
        route: { name: "formations-bachelor" },
      },
      {
        text: "Le campus",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/hes-so-valais-wallis/campus/campus-bellevue-sierre-205007",
          },
        },
      },
      {
        text: "Instituts de recherche",
        route: {
          name: "instituts-recherche",
        },
      },
      {
        text: "Service aux entreprises et institutions",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/services-aux-entreprises-et-institutions/",
          },
        },
      },
      {
        text: "Formation continue",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/hautes-ecoles/haute-ecole-de-gestion/formation-continue-haute-ecole-de-gestion/",
          },
        },
      },
      {
        text: "Test d'orientation",
        route: {
          name: "site",
          query: {
            url: "https://quiz.hevs.ch/bachelor-business-hevs-french/start?utm_source=Foire+du+Valais&amp;utm_medium=Tablette",
          },
        },
      },
    ],
    formations_bachelor: [
      {
        text: "Tourisme",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/hautes-ecoles/haute-ecole-de-gestion/tourisme/formation-bachelor-tourisme-200050",
          },
        },
      },
      {
        text: "Informatique de gestion",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/hautes-ecoles/haute-ecole-de-gestion/informatique-de-gestion/formation-bachelor-en-informatique-de-gestion-200049",
          },
        },
      },
      {
        text: "Economie d'entreprise",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/hautes-ecoles/haute-ecole-de-gestion/economie-d-entreprise/formation-bachelor-en-economie-d-entreprise/",
          },
        },
      },
    ],
    instituts: [
      {
        text: "Tourisme",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/recherche-appliquee-et-developpement-a-la-hes-so-valais-wallis/institut-tourisme-valais/",
          },
        },
      },
      {
        text: "Entrepreneuriat & management",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/recherche-appliquee-et-developpement-a-la-hes-so-valais-wallis/institut-entrepreneuriat-management-valais/",
          },
        },
      },
      {
        text: "Informatique",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/recherche-appliquee-et-developpement-a-la-hes-so-valais-wallis/institut-informatique-valais/",
          },
        },
      },
      {
        text: "Énergie et environnement",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/fr/recherche-appliquee-et-developpement-a-la-hes-so-valais-wallis/institut-de-recherche-energie-et-environnement/",
          },
        },
      },
    ],
  },

  de: {
    home: [
      {
        text: "Bachelor-ausbildungen",
        route: { name: "formations-bachelor" },
      },
      {
        text: "Unser Campus",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/fachhochschule-wallis/campus/campus-bellevue--siders-205007",
          },
        },
      },
      {
        text: "Forschungsinstitute",
        route: {
          name: "instituts-recherche",
        },
      },
      {
        text: "Dienstleistungs-angebote für Unternehmen und Institutionen",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/dienstleistungsangebot/",
          },
        },
      },
      {
        text: "Weiterbildung",
        route: {
          name: "formation-continue",
        },
      },
      {
        text: "Orientierungstest",
        route: {
          name: "site",
          query: {
            url: "https://quiz.hevs.ch/bachelor-business-hevs-german/start?utm_source=Foire+du+Valais&amp;utm_medium=Tablette&amp;utm_campaign=DE",
          },
        },
      },
    ],
    formations_bachelor: [
      {
        text: "Tourismus",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/Hochschule/hochschule-fur-wirtschaft/tourismus/bachelor-in-tourismus-200050",
          },
        },
      },
      {
        text: "Wirtschafs-informatik",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/Hochschule/hochschule-fur-wirtschaft/wirtschaftsinformatik/bachelorausbildung-in-wirtschaftsinformatik-200049",
          },
        },
      },
      {
        text: "Betriebsökonomie",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/Hochschule/hochschule-fur-wirtschaft/betriebsokonomie/bachelorausbildung-in-betriebsokonomie/",
          },
        },
      },
    ],
    instituts: [
      {
        text: "Tourismus",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/anwendungsorientierte-forschung-entwicklung/das-institut-tourismus-der-fachhochschule-wallis/",
          },
        },
      },
      {
        text: "Unternehmertum & Management",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/anwendungsorientierte-forschung-entwicklung/das-institut-entrepreneuship-management/",
          },
        },
      },
      {
        text: "Informatik",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/anwendungsorientierte-forschung-entwicklung/das-institut-informatik-der-fachhochschule-wallis/",
          },
        },
      },
      {
        text: "Energie und Umwelt",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/anwendungsorientierte-forschung-entwicklung/forschungsinstitut-energie-und-umwelt/",
          },
        },
      },
    ],
    formation_continue: [
      {
        text: "Weiterbildung Informatik",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/Hochschule/hochschule-fur-wirtschaft/wirtschaftsinformatik/weiterbildung-informatik-200230",
          },
        },
      },
      {
        text: "Weiterbildung Tourismus",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/Hochschule/hochschule-fur-wirtschaft/tourismus/weiterbildung-tourismus-200232",
          },
        },
      },
      {
        text: "Weiterbildung Betriebsökonomie",
        route: {
          name: "site",
          query: {
            url: "https://www.hevs.ch/de/Hochschule/hochschule-fur-wirtschaft/betriebsokonomie/weiterbildung-betriebsokonomie-200229",
          },
        },
      },
    ],
  },
};

function getButtons(lang = "fr", section = "home") {
  return buttonsConfig[lang]?.[section] || buttonsConfig["fr"][section];
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
